import { JobTitle } from '@accredible-frontend-v2/models';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CareerPreference, SetYourGoalPayload } from '../entities/set-your-goal.model';
import { CareerPreferenceApiService } from './career-preference-api.service';

@Injectable({ providedIn: 'root' })
export class SetYourGoalService {
  private readonly careerPreferenceApi = inject(CareerPreferenceApiService);

  submitGoal(payload: SetYourGoalPayload): Observable<CareerPreference> {
    return this.careerPreferenceApi.updateCareerPreference({
      career_preference: {
        career_goal: payload.goalId,
        ...(payload.currentJobTitleId && { current_job_title_id: payload.currentJobTitleId }),
        ...(payload.targetJobTitleId && { target_job_title_id: payload.targetJobTitleId }),
        ...(payload.fieldOfStudy && { field_of_study: payload.fieldOfStudy }),
      },
    });
  }

  searchJobTitles(query: string): Observable<JobTitle[]> {
    return this.careerPreferenceApi.searchJobTitles(query);
  }
}
